import type { OverrideBasis, OverrideSet } from './types';

const VALID_BASES: ReadonlyArray<OverrideBasis> = ['vendor_revenue', 'room_nights'];

// Mirrors svc-offer `pricingToolDraftValidator.ts` override tier rules: each tier's
// `to` and `comms` are required numbers, `from` (when present) must be less than `to`,
// and tiers must be ordered by increasing `to`.
export function validateOverrides(values: OverrideSet): Array<string> {
  const errors: Array<string> = [];

  if (!VALID_BASES.includes(values.basis)) {
    errors.push('Basis must be vendor_revenue or room_nights.');
  }

  let previousTo: number | undefined;
  values.tiers.forEach((tier, index) => {
    if (typeof tier.to !== 'number' || !Number.isFinite(tier.to)) {
      errors.push(`Tier ${index + 1}: "to" is required and must be a number.`);
    }

    if (typeof tier.comms !== 'number' || !Number.isFinite(tier.comms)) {
      errors.push(`Tier ${index + 1}: "comms" is required and must be a number.`);
    }

    if (tier.from !== undefined && typeof tier.to === 'number' && tier.from >= tier.to) {
      errors.push(`Tier ${index + 1}: "from" must be less than "to".`);
    }

    if (previousTo !== undefined && typeof tier.to === 'number' && tier.to <= previousTo) {
      errors.push(`Tier ${index + 1}: tiers must be ordered by increasing "to".`);
    }

    previousTo = typeof tier.to === 'number' ? tier.to : previousTo;
  });

  return errors;
}
